import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { FC } from 'react';

interface ConfirmModalActionsProps {
  onClose: () => void;
  onConfirm: () => void;
  cancelText?: string;
  confirmText?: string;
}

export const ConfirmModalActions: FC<ConfirmModalActionsProps> = ({
  onClose,
  onConfirm,
  cancelText,
  confirmText,
}) => {
  return (
    <Box
      display="flex"
      flexDirection="row"
      justifyContent="flex-end"
      sx={(theme) => ({
        '& button:not(:first-child)': {
          marginLeft: theme.spacing(2),
        },
      })}
    >
      <Button variant="text" onClick={onClose} size="small">
        {cancelText || 'Cancel'}
      </Button>
      <Button variant="contained" color="primary" onClick={onConfirm} size="small">
        {confirmText || 'Confirm'}
      </Button>
    </Box>
  );
};
